var _g, _g2, _g3;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgReadingListSvgrepoCom(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "209px",
    height: "209px",
    viewBox: "0 0 28.00 28.00",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    stroke: "#a0a0a0",
    strokeWidth: 1.3439999999999999,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_bgCarrier",
    strokeWidth: 0
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_tracerCarrier",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_iconCarrier"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3.50439 7.50955C3.50439 6.41681 4.39023 5.53098 5.48297 5.53098C6.16933 5.53098 6.77453 5.87984 7.1305 6.4134C7.36038 6.75796 7.82607 6.85094 8.17063 6.62105C8.5152 6.39117 8.60817 5.92549 8.37829 5.58092C7.75593 4.64807 6.69167 4.03098 5.48297 4.03098C3.56181 4.03098 2.00439 5.58839 2.00439 7.50955C2.00439 9.41841 3.54191 10.9682 5.44609 10.9879C5.4898 10.9959 5.53482 11 5.58081 11H21.2522C21.6664 11 22.0022 10.6642 22.0022 10.25C22.0022 9.83579 21.6664 9.5 21.2522 9.5H5.61663C5.57326 9.4922 5.52859 9.48812 5.48297 9.48812C4.39023 9.48812 3.50439 8.60229 3.50439 7.50955Z",
    fill: "#212121"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.75 6C11.3358 6 11 6.33579 11 6.75C11 7.16421 11.3358 7.5 11.75 7.5H25.25C25.6642 7.5 26 7.16421 26 6.75C26 6.33579 25.6642 6 25.25 6H11.75Z",
    fill: "#212121"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.75 13.25C6.33579 13.25 6 13.5858 6 14C6 14.4142 6.33579 14.75 6.75 14.75H25.25C25.6642 14.75 26 14.4142 26 14C26 13.5858 25.6642 13.25 25.25 13.25H6.75Z",
    fill: "#212121"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.99768 17.75C1.99768 17.3358 2.33347 17 2.74768 17H21.2477C21.6619 17 21.9977 17.3358 21.9977 17.75C21.9977 18.1642 21.6619 18.5 21.2477 18.5H2.74768C2.33347 18.5 1.99768 18.1642 1.99768 17.75Z",
    fill: "#212121"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.74536 20.5C6.33115 20.5 5.99536 20.8358 5.99536 21.25C5.99536 21.6642 6.33115 22 6.74536 22H25.2454C25.6596 22 25.9954 21.6642 25.9954 21.25C25.9954 20.8358 25.6596 20.5 25.2454 20.5H6.74536Z",
    fill: "#212121"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgReadingListSvgrepoCom);
export default __webpack_public_path__ + "static/media/reading-list-svgrepo-com.926177299aa1a6e2159e0e79724b0a99.svg";
export { ForwardRef as ReactComponent };